export default {
   "sectdetails": {
      "fullname": "",
      "gender": "",
      "nationality": "",
      "race": "",
      "religion": "",
      "icpassport": "",
      "dob": "",
      "age": "",
      "pob": "",
      "contactmobile": "",
      "contactemail": "",
   },
   "secthome": {
      "homestreet": "",
      "homepostcode": "",
      "homecity": "",
      "homedistrict": "",
      "homestate": "",
      "homecountry": "",
      "homephone": "",
   },
   "sectwork": {
      "workcompany": "",
      "workjobtitle": "",
      "workdept": "",
      "workposition": "",
      "workstreet": "",
      "workpostcode": "",
      "workcity": "",
      "workdistrict": "",
      "workstate": "",
      "workcountry": "",
      "workphone": "",
      "workfax": "",
      "workemail": "",
   },
   "sectcontactpref": {
      "prefercontacthome": "",
      "prefercontactwork": "",
      "prefercontactemail": "",
   }

}
